import {styled} from "@mui/material";
import Button from "@mui/material/Button";

export const SamaggiButton = styled(Button, {
    shouldForwardProp: (prop) => !["colour", "hoverColour", "textColour", "hoverTextColour", "paddingX", "paddingY"].includes(prop as string)
})<{ colour?: string, hoverColour?: string, textColour?: string, hoverTextColour?: string, paddingX?: string, paddingY?: string }>
(({colour = "rgb(4,64,60)", hoverColour = "rgb(0,44,41)", textColour = "#FFFFFF", hoverTextColour = "#FFFFFF", paddingX = "initial", paddingY = "initial"}) => ({
    backgroundColor: colour,
    color: textColour,
    fontWeight: "600",
    borderRadius: "10px",
    minHeight: "45px",
    maxHeight: "65px",
    fontSize: "17px",
    borderWidth: "1px",
    paddingLeft: paddingX,
    paddingRight: paddingX,
    paddingTop: paddingY,
    paddingBottom: paddingY,
    borderColor: "#222222",
    boxShadow: "0 1px 3px #9E9E9E",
    "&:hover": {
        backgroundColor: hoverColour,
        color: hoverTextColour
    },
    fontFamily: "\"Montserrat\", \"Roboto\",\"Helvetica\",\"Arial\", sans-serif",
}))